// extracted by mini-css-extract-plugin
module.exports = {"cls1":"mobile-Background-module--cls1--2-nOy","cls2":"mobile-Background-module--cls2--K0kJP mobile-Background-module--cls1--2-nOy"};